<template>
	<div>
		<!-- 大屏显示 -->
		<div class="footer_comtent">
			<div class="footer_comtent_top">
				<div class="footer_comtent_top_comtent">
					<div style="width: 390px">
						<img src="../assets/home/logo-底部.png" alt="" />
					</div>
		 		<ul>
		 			<li>首页</li>
					<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
						&nbsp;
					</li>
					<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
						&nbsp;
					</li>
					<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
						&nbsp;
					</li>
					<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
						&nbsp;
					</li>
					</ul>
					<ul>
						<li>解决方案</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							信创安全科技
						</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							产业数智赋能  
						</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							&nbsp;
						</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							&nbsp;
						</li>
					</ul>
					<ul>
						<li>数字科技</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							人工智能
						</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							大数据
						</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							物联网
						</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							数字孪生
						</li>
					</ul>
					<!-- <ul>
						<li>公司动态</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							行业动态
						</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							公司动态
						</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							合作伙伴
						</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							&nbsp;
						</li>
					</ul> -->
					<ul>
						<li>关于我们</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							公司简介
						</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							资质荣誉
						</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							联系我们
		 			</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							&nbsp;
						</li>
					</ul>
					<ul class="ul_list" style="cursor: pointer">
						<li>关注我们</li>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
						</li>
						<div style="height: 76px;" >
							<img style="height: 76px;width:  76px;" src="../assets/home/组13.png" alt="" />
						</div>
						<li style="font-family: ArialMT; font-size: 14px; color: #a4a4a4">
							&nbsp;
						</li>
						  
					</ul>
				</div>
			</div>
			<!-- 底部信息 -->
			<div class="footer-module_copyright_O0Gf1">
			     版权所有 北京牛加科技发展有限公司 -
				<a style="margin-right: 30px" href="https://beian.miit.gov.cn/#/Integrated/index"
					target="_blank">京ICP备2024071819号-1 </a> 
			</div>
		</div>
		<!-- 小屏显示 -->
		<div class="moreover">
			<div class="center">
				<div class="top_logo">
					<img src="../assets/home/logo-底部.png" alt="" />
				</div>
				<div class="moreover_center">
					<ul>
						<li>关注我们</li>
						<li>
							<img style="width: 64px; height: 64px" src="../assets/home/组13.png" alt="" />
						</li>
 					</ul>
					<ul>
						<li>联系地址</li>
						<li style="font-family: ArialMT; color: #a4a4a4">
							北京市石景山区泰禾长安中心A座12层
						</li>
					</ul>
					<ul>
						<li style="color: #a4a4a4">
							<span> 版权所有 北京牛加科技发展有限公司 </span>
						</li>
						<li>
							<a style="margin-right: 30px; color: #a4a4a4"
								href="https://beian.miit.gov.cn/#/Integrated/index"
								target="_blank">京ICP备2022024109号-2</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {};
</script>

<style lang="scss" scoped>
	.footer_comtent {
		@media only screen and (min-width: 0px) and (max-width: 1200px) {
			display: none;
		}

		position: relative;
		width: 100vw;
		height: 225px;
		background: #041e50;

		.footer_comtent_top {
			display: flex;
			justify-content: center;
			width: 100%;
			height: 163px;
			border-bottom: 1px solid rgba(255, 255, 255, 0.2);

			// 大屏
			@media only screen and (min-width: 0px) and (max-width: 1200px) {
				border: 0px;
				height: 100%;
			}

			.footer_comtent_top_comtent {
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 66%;
				height: 100%;

				img {
					width: 115px;
					height: 34px;
				}

				ul {
					position: relative;
					width: 155px;

					li {
						font-size: 16px;
						font-family: SourceHanSansSC-Medium, SourceHanSansSC;
						font-weight: 500;
						color: #ffffff;
						margin-bottom: 5px;
					}

					.erwei {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 140px;
						height: 140px;
						box-sizing: border-box;
						position: absolute;
						background-color: #fff;
						top: -140px;
						left: 5px;
						display: none;

						img {
							width: 120px;
							height: 120px;
						}
					}
				}

				.ul_list:hover {
					.erwei {
						display: flex;
					}
				}
			}
		}

		.footer_comtent_bottom {
			display: flex;
			justify-content: center;
			width: 100%;
			height: 49%;

			.footer_comtent_bottom_comtent {
				box-sizing: border-box;
				padding-top: 45px;
				display: flex;
				justify-content: space-between;
				// align-items: center;
				width: 66%;
				height: 100%;

				ul {
					width: 155px;

					li {
						font-size: 16px;
						font-family: SourceHanSansSC-Medium, SourceHanSansSC;
						font-weight: 500;
						color: #ffffff;
						margin-bottom: 5px;
					}
				}
			}
		}

		.footer-module_copyright_O0Gf1 {
			position: absolute;
			bottom: 25px;
			display: flex;
			justify-content: center;
			width: 100%;
			color: #a4a4a4;
			font-size: 13px;

			a {
				color: #a4a4a4;
			}
		}

		.footer-module_copyright_O0Gf1 a:hover {
			color: #6ebb04;
		}
	}

	// 小屏显示
	.moreover {
		box-sizing: border-box;
		padding: 40px 20px;
		width: 100vw;
		background: #041e50;

		@media only screen and (min-width: 0px) and (max-width: 1199px) {
			display: block;
		}

		@media only screen and (min-width: 1200px) and (max-width: 2580px) {
			display: none;
		}

		.center {
			box-sizing: border-box;

			.top_logo {
				height: 50px;
				margin-bottom: 30px;

				img {
					width: 115px;
					height: 34px;
				}
			}

			.moreover_center {
				ul {
					margin-bottom: 40px;

					li {
						font-size: 15px;
						color: #fff;
						margin-bottom: 5px;
					}
				}
			}
		}
	}
</style>
